import React, { useState, useEffect } from 'react';
import { useAvatarUrl } from '../../hooks/useAvatarUrl';
import '../../css/chats/GroupReadReceipt.css';

/**
 * Аватар прочитавшего для списка read receipts.
 * Загружает blob URL через useAvatarUrl.
 */
function ReadReceiptAvatar({ profile, participants }) {
    // Ищем профиль участника по ID
    const participant = participants.find(p => p.id === profile.id || p.id === profile);
    const avatarFileId = participant?.avatar || null;
    const avatarBlobUrl = useAvatarUrl(avatarFileId);
    const displayName = participant?.displayName || 'Пользователь';

    return (
        <div
            className="group-read-receipt__avatar"
            title={displayName}
        >
            {avatarBlobUrl ? (
                <img
                    src={avatarBlobUrl}
                    alt={displayName}
                    className="group-read-receipt__avatar-img"
                />
            ) : (
                <span className="group-read-receipt__avatar-fallback">
                    {displayName.charAt(0).toUpperCase()}
                </span>
            )}
        </div>
    );
}

/**
 * Read receipts для групповых чатов.
 * Показывает первые 3 аватара прочитавших + "и ещё N" если больше.
 *
 * @param {Object} props
 * @param {Array} props.seenBy - Массив ID профилей (UUID) или объектов { id, userId, profileId }
 * @param {string} props.currentProfileId - ID профиля текущего пользователя (исключаем из списка)
 * @param {Array} props.participants - Массив участников чата { id, displayName, avatar }
 */
export default function GroupReadReceipt({ seenBy, currentProfileId, participants }) {
    if (!seenBy || !Array.isArray(seenBy) || seenBy.length === 0) return null;

    // Фильтруем: исключаем отправителя, нормализуем к массиву ID
    const readerIds = seenBy
        .map(s => {
            if (typeof s === 'string') return s;
            return s?.id || s?.userId || s?.profileId || null;
        })
        .filter(Boolean)
        .filter(id => id !== currentProfileId);

    if (readerIds.length === 0) return null;

    const maxVisible = 3;
    const visible = readerIds.slice(0, maxVisible);
    const extraCount = readerIds.length - maxVisible;

    return (
        <div className="group-read-receipt">
            {visible.map((id) => (
                <ReadReceiptAvatar
                    key={id}
                    profile={id}
                    participants={participants}
                />
            ))}
            {extraCount > 0 && (
                <span className="group-read-receipt__count" title={`Ещё ${extraCount}`}>
                    +{extraCount}
                </span>
            )}
        </div>
    );
}